export const selectSecondaryMenuItems = (state) => state.secondaryMenu.items;
export const selectSecondaryMenuLoading = (state) => state.secondaryMenu.loading;
export const selectSecondaryMenuError = (state) => state.secondaryMenu.error;

export const secondaryMenuSelectors = {
    selectSecondaryMenuItems,
    selectSecondaryMenuLoading,
    selectSecondaryMenuError,
};

export default secondaryMenuSelectors;
